import { useEffect, useState } from 'react';
import { Form } from 'antd';
import api from '../../../axiosConfig';

export function tiposLugar(form) {
  const result = { geografia_version_esperada: form.getFieldValue('geografia_version_esperada') };
  for (const lado of ['origen', 'destino']) {
    const value = form.getFieldValue(`${lado}_lugar`);
    const institucion = typeof value === 'number';
    result[`${lado}_tipo_lugar`] = institucion ? 'institucion' : value === 'Domicilio' ? 'domicilio' : 'temporal';
    result[`${lado}_institucion_id`] = institucion ? Number(value) : null;
  }
  return result;
}
export function invertirTipos(datos) {
  return { origen_tipo_lugar: datos.destino_tipo_lugar, origen_institucion_id: datos.destino_institucion_id,
    destino_tipo_lugar: datos.origen_tipo_lugar, destino_institucion_id: datos.origen_institucion_id };
}

export function domicilioPermitido(contexto, trayecto, lado) {
  if (!contexto?.configurada || !['Ida', 'Retorno'].includes(trayecto)) return null;
  if (lado !== (trayecto === 'Retorno' ? 'destino' : 'origen')) return null;
  const punto = contexto.domicilio_autorizacion;
  const regla = contexto.ambitos?.origen;
  if (!punto || !regla || !regla.departamentos.map(Number).includes(Number(punto.departamento_id))) return null;
  if (regla.modo !== 'todas' && !regla.ciudades.map(Number).includes(Number(punto.ciudad_id))) return null;
  return punto;
}

export default function useGeografiaTraslado(form, autorizacionInicial, trayectoInicial = 'Ida') {
  const autorizacionId = Form.useWatch('autorizacion_id', form) || autorizacionInicial;
  const trayecto = Form.useWatch('trayecto', form) || trayectoInicial;
  const [respuesta, setRespuesta] = useState(null);
  const contexto = String(respuesta?.autorizacionId) === String(autorizacionId) ? respuesta?.data : null;
  const [error, setError] = useState('');
  const versionFormulario = Form.useWatch('geografia_version_esperada', { form, preserve: true });
  useEffect(() => {
    // resetFields al reabrir el diálogo no debe perder la versión del contexto ya cargado.
    if (contexto && versionFormulario == null) form.setFieldValue('geografia_version_esperada', contexto.version);
  }, [contexto, versionFormulario, form]);
  useEffect(() => {
    let vigente = true; setRespuesta(null); setError(''); form.setFieldValue('geografia_version_esperada', null);
    if (!autorizacionId) return;
    api.get('/autorizaciones-geografia/contexto', { params: { autorizacion_id: autorizacionId } })
      .then(({data}) => { if (vigente) {setRespuesta({ autorizacionId, data }); form.setFieldValue('geografia_version_esperada', data.version); if (!data.configurada) setError('Esta autorización no tiene configuradas las ubicaciones permitidas. Edite la autorización y guarde los departamentos y ciudades de origen y destino antes de programar o cambiar el recorrido.');} })
      .catch(e => { if (vigente) setError(e.response?.data?.message || 'No se pudieron cargar las ubicaciones permitidas de la autorización. Cierre el formulario y vuelva a intentarlo.'); });
    return () => { vigente = false; };
  }, [autorizacionId]);
  const filtrar = (lista, tipo, lado) => {
    const key = trayecto === 'Retorno' ? (lado === 'origen' ? 'destino' : 'origen') : lado;
    const a = contexto?.configurada && contexto.ambitos?.[key];
    if (!a) return [];
    return lista.filter(item => {
      const dep = Number(tipo === 'departamento' ? item.id : item.departamento_id);
      const city = Number(tipo === 'ciudad' ? item.id : item.ciudad_id);
      return a.departamentos.includes(dep) && (tipo === 'departamento' || a.modo === 'todas' || a.ciudades.includes(city));
    });
  };
  return { contexto, error, filtrar, autorizacionId, domicilio: lado => domicilioPermitido(contexto, trayecto, lado) };
}
